var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclamationCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "exclamation-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    d: "M10 18.9583C5.06 18.9583 1.04167 14.94 1.04167 10C1.04167 5.06 5.06 1.04167 10 1.04167C14.94 1.04167 18.9583 5.06 18.9583 10C18.9583 14.94 14.94 18.9583 10 18.9583ZM10 2.29167C5.74917 2.29167 2.29167 5.74917 2.29167 10C2.29167 14.2508 5.74917 17.7083 10 17.7083C14.2508 17.7083 17.7083 14.2508 17.7083 10C17.7083 5.74917 14.2508 2.29167 10 2.29167ZM10.85 12.9167C10.85 12.4567 10.4775 12.0833 10.0167 12.0833H10.0083C9.54834 12.0833 9.17908 12.4567 9.17908 12.9167C9.17908 13.3767 9.55668 13.75 10.0167 13.75C10.4767 13.75 10.85 13.3767 10.85 12.9167ZM10.625 10.0592V6.25C10.625 5.905 10.345 5.625 10 5.625C9.655 5.625 9.375 5.905 9.375 6.25V10.0592C9.375 10.4042 9.655 10.6842 10 10.6842C10.345 10.6842 10.625 10.4042 10.625 10.0592Z",
    fill: "#FF6C22"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationCircle);
export default __webpack_public_path__ + "static/media/exclamation-circle.72d06696297147f7a5e9220c58a7ce8c.svg";
export { ForwardRef as ReactComponent };